import TableView from '@/components/leads/TableView';
import { Command, CommandInput } from '@/components/shadcn/ui/command';
import { useAuthContext } from '../../context/AuthContext';
import { BusinessTable } from '@/entities/business';
import { useBusiness } from '@/hook/useBusiness';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

interface LeadFormData {
  id: number;
  description: string;
  status: string | null;
  closedAt: string | null;
  startedAt: string | null;
  prevision: string | null;
  contactNumber: string | null;
  observation: string | null;
  value: number | null;
  companyId: number;
  situation: string;
  clientId: number | null;
  createdById: number;
  opportunityFlowId: number;
  activityTypes: {
    name: string ;
  } | null;
  opportunityFlow: {
    description: string
  } | null;
  client: {
    fantasyName: string
  } | null;
}
const LeadPage = () => {
  const {leadId} = useParams<{leadId:string}>();
  const leadId2Set = Number(leadId);
  const {accessToken} = useAuthContext();
  const {businessCompany,deleteBusiness,fetchBusiness} = useBusiness(leadId2Set, accessToken?.userId);
  const [leads, setLeads] = useState<LeadFormData[]>([]);

  useEffect(() => {
    const fetchData = async () => {
      const result = await businessCompany;
      setLeads(result); // Verifique os dados no console
    };
  
    fetchData();  // Chame a função assíncrona dentro do useEffect
  }, [businessCompany]);

  const handleLeadDelete = (index: number) => {
    const listLead = [...leads];
    deleteBusiness(listLead[index].id);
    listLead.splice(index, 1);
    setLeads(listLead);
  };

  return (
    <div className='min-h-screen bg-indigo-200 p-8'>
      <div className='min-h-100 flex flex-col overflow bg-white rounded-md py-4 mx-8 mb-4 '>   
        <div className='flex m-2 justify-between items-center pr-2'>
          <h1 className='m-4 text-md font-medium'>Negócios</h1>
          <div className='flex gap-6'>
            <Command className='flex items-center rounded-lg border-2 p-1 gap-1'>
              <CommandInput placeholder="Pesquisar..."/>
            </Command>
          </div>
        </div>
        <TableView
          data={leads}
          onLeadDelete={handleLeadDelete}
        />
        <div>
    
        </div>
      </div>
    </div>
  );
};

export default LeadPage;
